import clsx from "clsx";
import React from "react";

import styles from "./form-table.module.css";

export function FormTable({
  children,
  dataAdd,
  big,
  className,
}: {
  children?: React.ReactNode;
  dataAdd?: boolean;
  big?: boolean;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        styles.grid,
        dataAdd && styles.dataAdd,
        big && styles.big,
        className,
      )}
    >
      {children}
    </div>
  );
}
